import { usePlayer } from '@/hooks/player/usePlayer'
import { Navigate, Outlet } from 'react-router'

export function RequireOnboarding() {
  const { player, isLoading } = usePlayer()

  if (isLoading) {
    return (
      <div className="wefa-route-status">
        <p>Loading profile...</p>
      </div>
    )
  }

  if (!player) {
    return <Navigate to="/" replace />
  }

  if (!player.onboardingComplete) {
    return <Navigate to="/onboard" replace />
  }

  return <Outlet />
}
